// Display-only translation keys for the credit-proposal template's section titles and name.
// The English `title`/`name` values in credit-proposal-template.ts stay unchanged because they are
// part of the document content; these keys are only used where the titles are shown in the UI.
const SECTION_TITLE_KEYS: Record<string, string> = {
  'Credit Proposal': 'DOC_BUILDER.SECTION_TITLES.CREDIT_PROPOSAL',
  'Company Introduction': 'DOC_BUILDER.SECTION_TITLES.COMPANY_INTRODUCTION',
  Highlights: 'DOC_BUILDER.SECTION_TITLES.HIGHLIGHTS',
  'Repayments Terms': 'DOC_BUILDER.SECTION_TITLES.REPAYMENTS_TERMS',
  Financial: 'DOC_BUILDER.SECTION_TITLES.FINANCIAL',
  'Extra terms': 'DOC_BUILDER.SECTION_TITLES.EXTRA_TERMS',
  'Income Statement': 'DOC_BUILDER.SECTION_TITLES.INCOME_STATEMENT',
  'Finanical-Analysis-details': 'DOC_BUILDER.SECTION_TITLES.FINANCIAL_ANALYSIS_DETAILS',
  'Repayment Plan': 'DOC_BUILDER.SECTION_TITLES.REPAYMENT_PLAN',
  'Financial Analysis': 'DOC_BUILDER.SECTION_TITLES.FINANCIAL_ANALYSIS',
  'Score on Institutional Rating System Summary': 'DOC_BUILDER.SECTION_TITLES.IRS_SUMMARY',
  'Key Risks and Responses': 'DOC_BUILDER.SECTION_TITLES.KEY_RISKS',
  'Borrower Request for Funding': 'DOC_BUILDER.SECTION_TITLES.BORROWER_REQUEST',
  'Summary Terms and Conditions': 'DOC_BUILDER.SECTION_TITLES.SUMMARY_TERMS',
  Introduction: 'DOC_BUILDER.SECTION_TITLES.INTRODUCTION',
  'Score on Institutional Rating System': 'DOC_BUILDER.SECTION_TITLES.IRS',
  'Financial Performance': 'DOC_BUILDER.SECTION_TITLES.FINANCIAL_PERFORMANCE',
  'Microfinance Plus Update': 'DOC_BUILDER.SECTION_TITLES.MICROFINANCE_PLUS_UPDATE',
  'Borrower’s Proposal Review': 'DOC_BUILDER.SECTION_TITLES.BORROWER_PROPOSAL_REVIEW',
  Recommendations: 'DOC_BUILDER.SECTION_TITLES.RECOMMENDATIONS',
  'Calculate Repayment Plan': 'DOC_BUILDER.SECTION_TITLES.CALCULATE_REPAYMENT_PLAN',
  'Tentative Disbursements and Repayment Plan': 'DOC_BUILDER.SECTION_TITLES.TENTATIVE_DISBURSEMENTS',
  Documents: 'DOC_BUILDER.SECTION_TITLES.DOCUMENTS',
};

/** Translation key for a template title; unknown titles are returned as-is (the translate pipe passes them through). */
export function sectionTitleKey(title: string | null | undefined): string {
  return title ? SECTION_TITLE_KEYS[title] ?? title : '';
}
